










































































































import Vue from 'vue';
import Component from 'vue-class-component';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import FileManagement from '@/modules/shared/shared/components/FileManagement.vue';
import { DCLocations, ReportsTypes } from '@/modules/shared/shared/domain/constants/constants';
import { getMonthFullName } from '@/modules/shared/shared/domain/functions/date-functions';
import { capitalize } from '@/modules/shared/shared/domain/functions/string-functions';
import { layout } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';

@Component({
    name: 'report-registry',
    components: { FileManagement, SectionTitle },
})
export default class ReportRegistry extends Vue {
    reportsTypes = ReportsTypes;
    DCLocations = DCLocations;

    reportTypeSelected: number | null = null;

    DCLocation: string | null = null;

    date: string = '';
    picker: string = '';
    file: any;

    dateChange() {
        const date = this.picker.split('-');
        this.date = `${capitalize(getMonthFullName(parseInt(date[1]) - 1))}, ${date[0]}`;
        return this.date;
    }

    onFileChange(e) {
        this.file = e;
    }

    mounted() {
        this.changeTitle({ title: 'Informes', route: ['Registro'] });
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE) changeTitle!: (title: LayoutTitle) => void;
}
